import React from 'react';
import { Tooltip } from '@crystaldelta/loree-ui-components';
import { LintEditorFormatPropsType } from './lintEditorType';
import { EditorFormatButton } from './styledContents';
import lintStyle from '../editorUtilityFunctions/loreeInteractiveEditor.module.scss';
import { ReactComponent as BoldButton } from '../editorFormattingIcons/boldButton.svg';
import { ReactComponent as ItalicButton } from '../editorFormattingIcons/italicButton.svg';
import { ReactComponent as UnderlineButton } from '../editorFormattingIcons/underlineButton.svg';
import { IconDiv } from './utilityFunctions';
import { hasUnderlineInAnchor, setCssProperty } from '../editorExtensions/utilityFunctions';

export function TextFormatButton(props: LintEditorFormatPropsType) {
  const { editor, setIsItalicButtonActive } = props;
  if (!editor) {
    return null;
  }
  return (
    <>
      <EditorFormatButton
        className={
          editor.isActive('bold')
            ? `${lintStyle.formatButton} is-active`
            : `${lintStyle.textFormatButton}`
        }
        onClick={() => {
          editor.chain().focus().toggleBold().run();
        }}
      >
        <Tooltip info='Bold'>
          <IconDiv>
            <BoldButton className='textFormatButton' />
          </IconDiv>
        </Tooltip>
      </EditorFormatButton>
      <EditorFormatButton
        className={
          editor.isActive('italic')
            ? `${lintStyle.formatButton} is-active`
            : `${lintStyle.formatButton}`
        }
        onClick={() => {
          if (setIsItalicButtonActive) setIsItalicButtonActive(false);
          const italicstyle = editor.isActive('italic') ? 'normal' : 'italic';
          editor.chain().focus().setFontStyle(italicstyle).run();
          editor.chain().focus().toggleItalic().run();
          let styles: string = editor.getAttributes('link').styles ?? '';
          if (styles.toLowerCase().includes('font-style: italic')) {
            styles = setCssProperty(styles, 'font-style', '');
            editor.commands.updateAttributes('link', { styles });
          }
        }}
        disabled={props.enableIcon}
      >
        <Tooltip info='Italic'>
          <IconDiv enableIcon={props.enableIcon}>
            <ItalicButton className='textFormatButton' />
          </IconDiv>
        </Tooltip>
      </EditorFormatButton>
      <EditorFormatButton
        className={
          editor.isActive('underline')
            ? `${lintStyle.formatButton} is-active`
            : `${lintStyle.formatButton}`
        }
        onClick={() => {
          const { from, to } = editor.state.selection;
          editor.commands.toggleUnderline();
          if (hasUnderlineInAnchor(editor)) {
            const styles: string = editor.getAttributes('link').styles ?? '';
            const newAttrs = setCssProperty(styles, 'text-decoration', 'none');
            editor.commands.updateAttributes('link', { styles: newAttrs });
            editor.chain().unsetUnderline().run();
          }
          editor.chain().focus().setTextSelection({ from, to }).run();
        }}
      >
        <Tooltip info='Underline'>
          <IconDiv>
            <UnderlineButton className='textFormatButton' />
          </IconDiv>
        </Tooltip>
      </EditorFormatButton>
    </>
  );
}
